/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
 
/* eslint-disable no-console */
console.log("Hello World! (from create-block-aksiontech-static block)");
//Video modal code
        document.addEventListener('DOMContentLoaded', () => {
        const openBtn = document.getElementById('openVideoBtn');
        const closeBtn = document.getElementById('closeVideoBtn');
        const modal = document.getElementById('videoModal');
        const backdrop = document.querySelector('.modal-backdrop');
        const iframe = document.getElementById('heroVideo');
        
        // Store the src to reset it (stops video on close)
        const videoSrc = iframe.src;

        function openModal() {
            modal.classList.add('active');
            document.body.style.overflow = 'hidden'; // Prevent background scrolling
        }

        function closeModal() {
            modal.classList.remove('active');
            document.body.style.overflow = '';
            
            // Reset iframe src to stop video playing
            iframe.src = '';
            iframe.src = videoSrc;
        }

        openBtn.addEventListener('click', openModal);
        closeBtn.addEventListener('click', closeModal);
        backdrop.addEventListener('click', closeModal);

        // Close on Escape key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && modal.classList.contains('active')) {
                closeModal();
            }
        });
    });